import SectionHeader from './SectionHeader';
import { guideSteps } from '../../../mocks/gossip';

export default function Guide() {
  return (
    <section id="guide" className="mx-auto max-w-7xl scroll-mt-20 px-4 py-14 md:px-6 md:py-20">
      <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-14">
        <div>
          <SectionHeader eyebrow="新手也能上手" title="吃瓜指南" desc="别做只会喊前排的小白，掌握这四步，你也能成为一条龙吃透事件、带节奏不跑偏的资深吃瓜人。" />

          <div className="flex flex-col gap-4">
            {guideSteps.map((g) => (
              <div key={g.no} className="flex gap-4 rounded-lg border border-background-200/70 bg-background-50 p-4 md:p-5">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                  <i className={`${g.icon} text-xl`}></i>
                </span>
                <div className="flex-1">
                  <div className="flex items-baseline gap-2">
                    <span className="font-heading text-sm text-accent-500">{g.no}</span>
                    <h3 className="text-base font-bold text-foreground-950">{g.title}</h3>
                  </div>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{g.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="relative">
          <div className="overflow-hidden rounded-lg">
            <img
              src="https://readdy.ai/api/search-image?query=friends%20gathered%20around%20a%20table%20laughing%20while%20scrolling%20phones%20together%2C%20casual%20fun%20gossip%20session%20at%20home%2C%20warm%20cozy%20indoor%20lighting%2C%20lively%20social%20enjoyment%20concept%20photography&width=900&height=1100&seq=guide-img&orientation=portrait"
              alt="三五好友围坐一起刷手机吃瓜的温馨场景"
              title="呱呱吃瓜 - 和朋友一起前排吃瓜"
              className="h-full w-full object-cover"
            />
          </div>
          <div className="absolute -bottom-5 -left-3 flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-4 py-3 shadow-md md:-left-6">
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-100 text-primary-600">
              <i className="ri-user-heart-line text-xl"></i>
            </span>
            <div>
              <div className="font-heading text-lg leading-none text-primary-600">38.6w+</div>
              <div className="mt-0.5 text-xs text-foreground-500">围观网友前排蹲瓜</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}